<template lang="html">
  <div class="row">
    <div class="col-md-2">
      <image src="{{player_picture}}" alt="" class="image image-rounded" width="120px"/>
    </div>
    <div class="col-md-10">
      <div class="form-group">
        <label for="">Nombre Completo: </label>
        <br>
        <input type="text" v-model="registration.player.name">
        <input type="text" v-model="registration.player.middle_name">
        <br>
        <input type="text" v-model="registration.player.surname">
        <input type="text" v-model="registration.player.mothers_surname">
      </div>
      <div class="form-group">
        <label for="">Edad: </label><input type="text" v-model="registration.player.age">

      </div>
      <div class="form-group">
        <label for="">Teléfono: </label><input type="text" v-model="registration.player.phone">
        <label for="">E-mail: </label><input type="email" v-model="registration.player.email">
      </div>
      <div class="form-group">
        <label for="">Handicap: </label>
        <input type="text" v-model="registration.handicap">
      </div>
      <div class="form-group">
        <label for="">Hotel: </label>
        <input type="text" v-model="registration.hotel">
      </div>
      <div class="form-group">
        <label for="">Estado de la inscripción</label>
        <select class="" v-model="registration.status">
          <option value="0">Inscrito</option>
          <option value="1">Anulada</option>
          <option value="2">Rechazada</option>
          <option value="3">Activo</option>
          <option value="4">DQ (Descalificado)</option>
          <option value="5">NP (No se presenta)</option>
          <option value="6">R (Retirado)</option>
          <option value="7">NC (No Pasa el corte)</option>
        </select>
      </div>
      <div class="form-group">
        <label for="">Categoría</label>
        <select class="" v-model="registration.category_id">
          <option v-for="category in categories" value="{{ category.id}}">{{category.name}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import configure from '../../configure'
import {select} from 'vue-strap'
import {getConfigCategories} from '../../vuex/getters'

export default {
  vuex: {
    getters: {
      categories: getConfigCategories
    }
  },
  props: {
    registration: {default: null}
  },
  data: function () {
    return {
      category: false
    }
  },
  computed: {
    categories_options() {
      let options= []
      this.categories.forEach(o => {
        let option = {
          value: o.id,
          label: o.name
        }
        options.push(option)
      })
      return options
    },
    player_picture() {
      return configure.image_url + this.registration.player.picture
    }
  },
  ready: function () {},
  attached: function () {},
  methods: {},
  components: {
    VueSelect: select
  }
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** RegistrationEdit.vue?5ece3cb8
 **/